<section class="bg-banner pt-0 pb-0 banner-style03">
    <div class="hero-slider-wrapper">
        <img src="assets/images/banner/Skin-Concern-Treatments.jpeg" class="desktop-show" alt="Red Monk Wellness" />
        <img src="assets/images/banner/Skin-Concern-Treatments-mobile-size.jpeg" class="mobile-show" alt="Red Monk Wellness" />
    </div>
</section>



<!-- Skin Tightening & Rejuvenation start -->
<!-- ========================= -->

<section class="section-padding" [ngClass]="catIndex % 2 === 0 ? 'bg-blue-light' : 'bg-blue'"
    *ngFor="let group of categoryGroups; let catIndex = index">
    <div class="container">
        <div class="text-center">
            <h2 class="section-title"><span>{{ group.category }}</span></h2>
        </div>

        <div class="static-treatments-wrapper">
            <div class="treatment-card2" *ngFor="let t of group.treatments; trackBy: trackById">
                <div class="card-glow"></div>
                <div class="treatment-content">
                    <div class="treatment-icon">
                        <img [src]="imageBaseUrl + t.Image" (error)="setDefaultImage($event)"
                            [alt]="t.TreatmentName + ' Icon'">
                    </div>
                    <div class="treatment-info">
                        <h4 class="treatment-title">{{ t.TreatmentName }}</h4>
                        <p class="treatment-text">
                            <span class="advantages">Advantages - </span>{{ t.Advantages }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- ========================= -->
<!-- Skin Tightening & Rejuvenation end -->